import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { newUserSchema } from "../../Validations/User";
import { useFormik } from "formik";
import { LICENSED, PROFESSIONAL, TOKEN, deleteUserAsAdminApi, raiseNotificationApi, sendEmailApi, signUpApi } from "../../Constants";
import { validateEmail, getFriendlyAuthErrorMessage } from "../../Utils";
import { Context } from "Context/Context";
import {Amplify} from 'aws-amplify';
import {deleteUser, fetchAuthSession, signUp, updateMFAPreference} from 'aws-amplify/auth'
import awsConfig from "aws_config";
import HostedGoogleSignin from "./HostedGoogleSignin";
import SignupRole, { LAUNCH_ROLES } from "./SignupRole";
import TermsAndCondModal from "Modals/TermsAndCondModal";
import SignupRoleMsg from "./SignupRoleMsg";
import capitalize from "capitalize";
import QCRLogoMark from "Components/Icons/QCRLogoMark";
import EyeIcon from "Components/Icons/EyeIcon";
import FieldError from "Components/Element/FieldError";
import FormErrorBanner from "Components/Element/FormErrorBanner";
import { rememberFirmInvite } from "Components/Profile/firmInvite";

Amplify.configure(awsConfig);

const Signup = ({setCurrentPassword}) => {

    const {role} = useParams();

    const {makeApiCallFunc, userDetails, setUserDetails} = useContext(Context);
    const [showModal, setShowModal] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [roleType, setRoleType] = useState(role ? parseInt(role) : 1);
    const [isClient, setIsClient] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [apiError, setApiError] = useState("");
    // keep an outreach "Claim your firm" invite (?invite=...) for the claim step later
    useEffect(() => { rememberFirmInvite(); }, []);
    useEffect(() => {
        const parsedRole = role ? parseInt(role) : null;
        // Launch scope: only CLIENT and FIRM are selectable for now (see SignupRole.jsx).
        // A direct link to a role that isn't launched yet falls back to CLIENT instead of
        // landing on a role no card represents.
        setRoleType(parsedRole && LAUNCH_ROLES.includes(parsedRole) ? parsedRole : 1);
    },[role])


    const navigate = useNavigate();

    const raiseNotification = (data) => {
        makeApiCallFunc(
            raiseNotificationApi,
            {
                title : "Complete your profile",
                is_read : false,
                sender: "admin",
                type: "2",
                receiver:  data.user._id,
                content: "Profile completion is necessary to be able to view full details of the case. Please note that the information submitted will be requiring admin approval."
            },
            (data) => {
                navigate("/");
                console.log(data);
             },
             (data) => {
                navigate("/");
                console.log(data);
            }
            );
    }
    const submitSuccessCallback = (values) => {
        setCurrentPassword(values.password);
        navigate("/confirm");

    }
    const checkIfWorkMail = (values) =>
    {
        values.role = (isClient ? 1 : 2);

        if(!isClient && !validateEmail(values.email))
        {
            setApiError("Please use your work email");
            return false;
        }
        return true;
    }
    const onSubmit = async (values) =>
        {
            setApiError("");
            console.log("values", values);
            if(checkIfWorkMail(values))
            {
                try
                {
                    const user = await signUp({
                    username: values.email,
                    password: values.password,
                    options: {
                        userAttributes: {
                        email: values.email,
                        'custom:role': (isClient ? "1" : "2"),
                        name: values.firstName + " " + values.lastName
                        },
                    }
                    });
                    if(user)
                    {
                        makeApiCallFunc(signUpApi,
                            {...values, "role" : (roleType === 1 ? 1 : roleType === 5 ? 5 : 2),
                                isUserAssistant: (roleType === 3 ? true : false),
                                isUserFunder: (roleType === 4 ? true : false),
                                legalType: (roleType === 2 ? LICENSED : (roleType === 3 ? "Legal assistant" : ""))
                            },
                            ({data}) => {
                                setCurrentPassword(values.password);
                                setUserDetails(data?.user);
                                navigate("/confirm");
                            },
                            async (error) => {
                                console.log("error mongodb signup error but successful cognito" , error);
                                //delete cognito user and ask user to login again

                               setApiError(getFriendlyAuthErrorMessage(error))
                            },
                            null,
                            false,
                            true
                        )

                    }
                    else
                    {
                        setApiError("Cannot sign up. Please try again later");
                    }

                }
                catch (error) {
                    console.log('error signing up:', error);
                    setApiError(getFriendlyAuthErrorMessage(error));
                }
            }
        }
    const handleFocus = (e) =>
    {
      setApiError("");
    }
    const {values, errors, touched, handleBlur, handleChange, handleSubmit, isSubmitting, setFieldValue} = useFormik({
        initialValues: {
            email: "",
            password: "",
            firstName: "",
            lastName: "",
            terms: false,
        },
        validationSchema : newUserSchema,
        onSubmit,
    })

   const getRegisterText = () => {
    switch(roleType)
    {
        case 1:
            return "Register as a Potential Client";
        case 2:
            return "Register as a Licensed Attorney";
        case 3:
            return "Register as a Legal Assistant";
        case 4:
            return "Register as a Litigation Funder";
        case 5:
        return "Register as a Law Firm";
        default:
            return "Register";
    }
    }
    const getSignupRoleText = () => {
        switch(roleType)
        {
            case 1:
                return "Potential Client";
            case 2:
                return "Licensed Attorney";
            case 3:
                return "Legal Assistant";
            case 4:
                return "Litigation Funder";
            case 5:
                return "Law Firm";
            default:
                return "User";
        }}

return (
    <>
    {
        showModal &&
        <TermsAndCondModal
        uploadNew={showModal}
        onClose={()=>setShowModal(false)}
        onDecline = {() => {setFieldValue("terms", false); setShowModal(false)}}
        onSubmit = {() => {setFieldValue("terms", true); setShowModal(false)}}
        />
    }
    <div className="min-h-screen w-full bg-cream font-plexsans flex flex-col items-center">
        <div className="w-full bg-ivory border-b border-navy/10 flex justify-center py-4 lg:py-5">
            <Link to="/" className="flex items-center gap-2">
                <QCRLogoMark/>
                <span className="flex items-start gap-1">
                    <span className="font-plexsans font-semibold text-[12px] tracking-wide uppercase text-navy">Quick Case Review</span>
                    <span className="font-plexmono font-medium text-[7px] tracking-widest uppercase text-tan mt-px">Beta</span>
                </span>
            </Link>
        </div>

        <div className="w-full flex-1 flex items-start lg:items-center justify-center px-4 py-10 lg:py-14">
        <div className="w-full max-w-[460px]">
        <div className="bg-ivory border border-navy/[0.14] rounded p-7 lg:p-8">

        {
        showForm ?
        <>
        <div className="flex items-center gap-2.5 mb-7 justify-center">
            <button
                type="button"
                aria-label="Back"
                onClick={() => setShowForm(false)}
                className="font-plexsans text-[17px] text-tan cursor-pointer bg-transparent border-none p-0"
            >
                ←
            </button>
            <h2 className="font-spectral font-normal text-navy text-[19px] lg:text-[20px] m-0">{getRegisterText()}</h2>
        </div>

        <div className="font-plexsans w-full flex flex-col">

            <FormErrorBanner>{apiError}</FormErrorBanner>

            <div className="flex flex-col gap-3">
                <div>
                    <input
                        type="text"
                        name="email"
                        placeholder={roleType === 1 ? "Email id" : "Official email id"}
                        value={values.email}
                        onChange={(e) => setFieldValue("email", e.target.value.toLowerCase())}
                        onBlur={handleBlur}
                        onFocus={handleFocus}
                        className={"w-full font-plexsans text-[14px] text-navy px-3.5 py-3.5 bg-cream border rounded-sm outline-none placeholder:text-navy/40" + (errors.email && touched.email ? " border-red-500" : " border-navy/[0.18]")}
                    />
                    {errors.email && touched.email && <FieldError>{errors.email}</FieldError>}
                </div>
                <div className="flex flex-col md:flex-row gap-3">
                    <div className="flex-1">
                        <input
                            type="text"
                            name="firstName"
                            placeholder="First Name"
                            value={values.firstName}
                            onChange={(e) => setFieldValue("firstName", capitalize(e.target.value))}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                            className={"w-full font-plexsans text-[14px] text-navy px-3.5 py-3.5 bg-cream border rounded-sm outline-none placeholder:text-navy/40" + (errors.firstName && touched.firstName ? " border-red-500" : " border-navy/[0.18]")}
                        />
                        {errors.firstName && touched.firstName && <FieldError>{errors.firstName}</FieldError>}
                    </div>
                    <div className="flex-1">
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Last Name"
                            value={values.lastName}
                            onChange={(e) => setFieldValue("lastName", capitalize(e.target.value))}
                            onBlur={handleBlur}
                            onFocus={handleFocus}
                            className={"w-full font-plexsans text-[14px] text-navy px-3.5 py-3.5 bg-cream border rounded-sm outline-none placeholder:text-navy/40" + (errors.lastName && touched.lastName ? " border-red-500" : " border-navy/[0.18]")}
                        />
                        {errors.lastName && touched.lastName && <FieldError>{errors.lastName}</FieldError>}
                    </div>
                </div>
                <div>
                    <div className="relative">
                        <input
                            type={!showPassword ? "password" : "text"}
                            name="password"
                            id="password"
                            placeholder="Password"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            onFocus={() => setApiError("")}
                            className={"w-full font-plexsans text-[14px] text-navy px-3.5 py-3.5 pr-11 bg-cream border rounded-sm outline-none placeholder:text-navy/40" + (errors.password && touched.password ? " border-red-500" : " border-navy/[0.18]")}
                        />
                        <button
                            type="button"
                            aria-label={showPassword ? "Hide password" : "Show password"}
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute inset-y-0 right-0 flex items-center mr-3.5 text-navy/50 bg-transparent border-none p-0 cursor-pointer"
                        >
                            <EyeIcon open={showPassword}/>
                        </button>
                    </div>
                    {errors.password && touched.password && <FieldError>{errors.password}</FieldError>}
                </div>
            </div>

            <label className="flex items-start gap-2.5 mt-4 font-plexsans text-[13px] leading-[1.5] text-navy cursor-pointer">
                <input
                    id="checkbox"
                    type="checkbox"
                    checked={values.terms}
                    onChange={handleChange}
                    name="terms"
                    onBlur={handleBlur}
                    className="mt-0.5 w-4 h-4 flex-none accent-tan"
                />
                <span>I accept the <span className="underline underline-offset-2 cursor-pointer" onClick={(e)=>{
                    e.preventDefault();
                    setShowModal(true);
                }}>Terms and Conditions</span>.</span>
            </label>
            {errors.terms && touched.terms && <FieldError>{errors.terms}</FieldError>}

            <button
                type="button"
                disabled={isSubmitting}
                onClick={handleSubmit}
                className={"w-full font-plexsans font-medium text-[14px] text-ivory bg-tan hover:bg-tanDark rounded-sm py-3.5 mt-5 transition-colors cursor-pointer" + (isSubmitting ? " opacity-50 cursor-not-allowed" : "")}
            >
                Sign up as a {getSignupRoleText()}
            </button>

            {roleType === 1 ?
            <>
                <div className="flex items-center gap-3 my-4">
                    <div className="flex-1 h-px bg-navy/[0.16]" />
                    <span className="font-plexsans text-[12px] text-navy/50">Or</span>
                    <div className="flex-1 h-px bg-navy/[0.16]" />
                </div>
                <HostedGoogleSignin/>
            </>
            : ""
            }

        </div>
        </>
        :
        <>
           <h2 className="font-spectral font-normal text-navy text-[22px] lg:text-[23px] text-center m-0">
                Choose how you'd like to join
            </h2>
            {/* <SignupRoleMsg roleType={roleType}/> */}
            <SignupRole
            roleType={roleType}
            setRoleType={setRoleType}
            setShowForm = {setShowForm}
            />
        </>

        }
        </div>
        <div className="flex justify-center mt-5 font-plexsans text-[12.5px]">
            <Link to="/signin/" className="text-navy underline underline-offset-2">Already have an account? Log in here</Link>
        </div>
        </div>
        </div>
    </div>
    </>
)
}

export default Signup;
